module.exports = __webpack_public_path__ + "img/guanzhu.60462860.svg";